import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import FormHelperText from "@material-ui/core/FormHelperText";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import PiiOverrideDialog from "./PiiOverrideDialog";
import styles from "./index.module.scss";

const PII_LABEL_KEYS = {
  EMAIL: "labelEmail",
  PHONE: "labelPhone",
  NATIONAL_ID: "labelNationalId",
  PASSPORT: "labelPassport",
  PAYMENT_CARD: "labelPaymentCard",
  BANK_ACCOUNT: "labelBankAccount",
  CLIENT_NAME_KNOWN: "labelName",
  CLIENT_NAME_HEURISTIC: "labelName",
  CAMPAIGN_KNOWN: "labelCampaign",
  CLIENT_COMPANY_KNOWN: "labelCompany",
  SUB_FUNCTIONAL_UNIT_KNOWN: "labelSubFunctionalUnit",
};

const PiiDetectionRow = ({ hit, onRequestOverride }) => {
  const { t } = useTranslation();
  const label = t(`pii.${PII_LABEL_KEYS[hit.type] || "labelName"}`);

  return (
    <Box className={styles.row}>
      <Box className={styles.rowHeader}>
        <span className={styles.rowText}>
          {label}: {hit.value}
        </span>
      </Box>
      <Tooltip title={t("pii.markAsSafeTooltip")}>
        <IconButton
          size="small"
          className={styles.rowIcon}
          aria-label={t("pii.markAsSafeTooltip")}
          onClick={() => onRequestOverride(hit)}
        >
          <CheckCircleOutlineIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

/**
 * Renders under a PII-flagged field: the red error message plus a
 * per-occurrence breakdown of what was detected, each row individually
 * resolvable via a "mark as safe" popup (with a required reason).
 */
const PiiDetectionPanel = ({ hits, onOverride }) => {
  const { t } = useTranslation();
  const [activeHit, setActiveHit] = useState(null);

  if (!hits || hits.length === 0) return null;

  return (
    <Box mt={0.5}>
      <FormHelperText error className={styles.errorMessage}>
        {t("pii.errorMessage")}
      </FormHelperText>
      <Box className={styles.panel}>
        <div className={styles.header}>{t("pii.removeOrMarkSafe")}</div>
        <div className={styles.rowsContainer}>
          {hits.map(hit => (
            <PiiDetectionRow key={hit.key} hit={hit} onRequestOverride={setActiveHit} />
          ))}
        </div>
      </Box>
      <PiiOverrideDialog
        activeHit={activeHit}
        onCancel={() => setActiveHit(null)}
        onOverride={(hit, reason) => {
          onOverride(hit, reason);
          setActiveHit(null);
        }}
      />
    </Box>
  );
};

export default PiiDetectionPanel;
